import {
    fetchBudgetListSuccessful,
    fetchBudgetListFailure,
    addNewBudgetTransactionSuccessful,
    addNewBudgetTransactionFailure,
    updateTheBudgetTransactionSuccessful,
    updateTheBudgetTransactionFailure,
    deleteTheBudgetTransactionSuccessful,
    deleteTheBudgetTransactionFailure,
    getGraphDataOfSelectedPeriodSuccessful,
    getTotalBudgetSummarizeSuccessful,
    getTotalBudgetSummarizeFailure, updateCurrencySuccessful, updateCurrencyFailure,
} from "../actions/budget";
import { createReducer } from "redux-act";

const DEFAULT_USER = {
  budget: [],
  currency: {
    symbol: '',
    code: ''
  },
  updateBudget: [],
  deleteBudget: [],
  graphData: { total: 0, categories: [] },
  totalBudgetSummarize: {
    expense: "",
    income: "",
    totalBudget: "",
  },
};

export default createReducer(
  {
    [fetchBudgetListSuccessful]: (state, payload) => {
      let currencyInfo = payload.currency ? payload.currency : payload.locale === "tr"
      ? {symbol:"₺", code:"TRY"}
      : {symbol:"$", code:"USD"}
      return {
        ...state,
        budget: payload.budgetList,
        currency: currencyInfo,
      };
    },
    [fetchBudgetListFailure]: (state, payload) => {
      return {
        ...DEFAULT_USER,
      };
    },

    [updateTheBudgetTransactionSuccessful]: (state, payload) => {
      return {
        ...state,
        updateBudget: payload,
      };
    },
    [updateTheBudgetTransactionFailure]: (state, payload) => {
      return {
        ...state,
      };
    },

    [deleteTheBudgetTransactionSuccessful]: (state, payload) => {
      return {
        ...state,
        deleteBudget: payload,
      };
    },
    [deleteTheBudgetTransactionFailure]: (state, payload) => {
      return {
        ...state,
      };
    },
    [getGraphDataOfSelectedPeriodSuccessful]: (state, payload) => {
      return {
        ...state,
        graphData: { ...payload },
      };
    },
    [getTotalBudgetSummarizeSuccessful]: (state, payload) => {
      return {
        ...state,
        totalBudgetSummarize: { ...payload },
      };
    },
    [getTotalBudgetSummarizeFailure]: (state, payload) => {
      return {
        ...state,
      };
    },
    [updateCurrencySuccessful]: (state, payload) => {
      return {
        ...state,
          };
    },
      [updateCurrencyFailure]: (state, payload) => {
          return {
              ...state,
          };
      },
  },
  DEFAULT_USER
);
